import React from 'react';
import { SIZES } from '../../fundamentals/sizes/sizes';
import { useTestId } from '../../hooks/useTestId/useTestId';
import { Button } from '../Button/Button';
import { BUTTON_MODES, BUTTON_VARIANTS } from '../Button/buttonVariants';
import { MATERIAL_ICONS } from '../Icon/icons';
import { LinkButton } from '../LinkButton/LinkButton';

export type MoreLinkSize = typeof SIZES.X_SMALL | typeof SIZES.SMALL | typeof SIZES.MEDIUM | typeof SIZES.LARGE;

export interface IMoreLinkProps {
  asButton?: boolean;
  size?: MoreLinkSize;
  children?: string;
  onClick?: () => void;
}

export const MoreLink: React.FC<IMoreLinkProps> = ({ children, size = SIZES.SMALL, asButton = false, onClick, ...rest }) => {
  const { generateTestId } = useTestId(rest, 'MoreLink');

  const sharedButtonProps = {
    size,
    endIcon: MATERIAL_ICONS.KeyboardDoubleArrowRight,
    onClick
  };

  return (
    <>
      {asButton ? (
        <Button variant={BUTTON_VARIANTS.PRIMARY} mode={BUTTON_MODES.OUTLINE} {...sharedButtonProps} {...generateTestId('Button')}>
          {children}
        </Button>
      ) : (
        <LinkButton {...sharedButtonProps} {...generateTestId('Link')}>
          {children}
        </LinkButton>
      )}
    </>
  );
};
